import { loadImages, autoLoadComponents } from '@/js/utils/auto-loader.js';
import '@/js/tabs.js';
import '@/js/parallax.js';

// Initialize shared loaders
const images = loadImages();

import '@/css/main.scss';

const components = autoLoadComponents();